import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { TokenControlService } from "../../services/state/tokenControl.service";
import { StateService } from "../../services/state/state.service";
import { State } from '../../model/state';
import { OfflineService } from '../../services/data/offline.service';
import { CONFIG } from '../../constants/constants';



declare var $: any;
@Component({
  selector: 'tour-inci',
  templateUrl: './web.tour.inci.component.html',
  providers: []
})
export class WebTourInciComponent {


  constructor(private _router: Router,
    private _tokenController: TokenControlService,
    private _stateService: StateService,
    private _offlineService: OfflineService,) {



  }

  ngAfterViewInit() {

  }


  ngOnInit() {
    $("#welcome").focus();
  }

  /*Es invocado cuando se hace click en finalizar el tour de ayuda
    y se encarga de navegar hacia el visualizador*/
  public startTest() {
    if (CONFIG.ONLINE == false) {
      this._stateService.state = new State(1, this._tokenController.token.sesion, 1, this._offlineService.credential.idCredencial);
    }
    console.log('Redirecting to::');
    this._router.navigate(['/viewtest']);
  }


}
